export default __webpack_public_path__ + "static/media/portfolio-logo.132f1123.png";